import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from "../../../core/service/command/command-handler-resolver.service";
import { rentalObjectCommand } from '../../command/rental-object.command';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { DwellingExportCommandHandler } from './dwelling-export-command-handler.service';
import { ShowRentalObjectInvoicesCommandHandler } from './show-rental-object-invoices-command-handler';
import { LinkRentalObjectDocumentCommandHandler } from './link-rental-object-document-command-handler.service';
import { ShowRentalObjectDocumentsCommandHandler } from './show-rental-object-documents-command-handler.service';
import { AdvertiseRentalObjectCommandHandler } from './advertise-rental-object-command-handler.service';
import { FeeChangeCommandHandler } from './fee-change-command-handler.service';
import { CopyRoomsCommandHandler } from './copy-rooms-command-handler.service';
import { PrintStairCaseListCommandHandler } from './print-staircaselist-command-handler';
import { SetLettingFeaturesCommandHandler } from './set-letting-features-command-handler.service';
import { SendToHomeQCommandHandler } from './send-to-homeq-command-handler.service';
import { PrintBrokerInformationCommandHandler } from './print-broker-information-command-handler.service';
import { ChangeRentalObjectCategoryCommandHandler } from './change-rental-object-category-command-handler.service';

@Injectable()
export class DwellingCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    deleteHandler: DeleteCommandHandler,
    editHandler: EditCommandHandler,
    exportHandler: DwellingExportCommandHandler,
    showInvoices: ShowRentalObjectInvoicesCommandHandler,
    linkDocumentHandler: LinkRentalObjectDocumentCommandHandler,
    showDocumentHandler: ShowRentalObjectDocumentsCommandHandler,
    advertiseHandler: AdvertiseRentalObjectCommandHandler,
    feeChangeHandler: FeeChangeCommandHandler,
    copyRoomsHandler: CopyRoomsCommandHandler,
    sendToHomeQHandler: SendToHomeQCommandHandler,
    setLettingFeaturesHandler: SetLettingFeaturesCommandHandler,
    printStairCaseListHandler: PrintStairCaseListCommandHandler,
    printBrokerInformationHandler: PrintBrokerInformationCommandHandler,
    changeCategoryHandler: ChangeRentalObjectCategoryCommandHandler,
  ) {
    super();
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.edit, editHandler);
    this.addHandler(rentalObjectCommand.export, exportHandler);
    this.addHandler(rentalObjectCommand.showInvoices, showInvoices);
    this.addHandler(rentalObjectCommand.linkDocument, linkDocumentHandler);
    this.addHandler(rentalObjectCommand.showDocuments, showDocumentHandler);
    this.addHandler(rentalObjectCommand.advertise, advertiseHandler);
    this.addHandler(rentalObjectCommand.feeChange, feeChangeHandler);
    this.addHandler(rentalObjectCommand.copyRooms, copyRoomsHandler);
    this.addHandler(rentalObjectCommand.sendToHomeQ, sendToHomeQHandler);
    this.addHandler(rentalObjectCommand.setLettingFeatures, setLettingFeaturesHandler);
    this.addHandler(rentalObjectCommand.showStairCaseList, printStairCaseListHandler);
    this.addHandler(rentalObjectCommand.printBrokerInformation, printBrokerInformationHandler)
    this.addHandler(rentalObjectCommand.changeCategory, changeCategoryHandler);
  }
}
